<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" :stroke="color" stroke-width="2"/>
    <path d="M12 7v5l3 3" :stroke="color" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'IconClockTimer',
  props: {
    size: { type: [Number, String], default: 20 },
    color: { type: String, default: '#B45309' }
  }
}
</script>
